import React, { useState, memo } from 'react'

import MenuBrowser from './MenuBrowser'
import { motion } from 'framer-motion'

import { FILTERED_US_STATES } from '../../../domain/useCases/navBar/constants'
import { NavSubItems } from './NavSubItems'
import transformTextToSlug from '../../../utils/transformTextToSlug'
import { getNavBrowseAllProps } from '@/domain/useCases/navBar/getNavBrowseAllProps.ts'
import { NavBrowseButton } from './NavBrowseButton'
const conVariants = {
  hidden: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2,
      delay: 0.5
    }
  },
  animate: {
    opacity: 1,
    translateX: '0px',
    transition: {
      duration: 0.2
    }
  },
  exit: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2
    }
  }
}

const UnitedStatesMenu = ({ setPage, page }) => {
  const [state, setState] = useState({ open: 'United States' })
  const setOpen = (id) => {
    if (state.open === id) {
      setState({ open: null })
    } else {
      setState({
        open: id
      })
    }
  }
  const NavBrowseButtonProps = getNavBrowseAllProps('United States')
  const US_LINKS = FILTERED_US_STATES.map((state) => {
    return {
      link: `/${transformTextToSlug(state)}/`,
      label: state
    }
  })

  return (
    <motion.div
      variants={conVariants}
      initial="hidden"
      animate="animate"
      exit={{ x: -300, opacity: 0 }}
    >
      <div className="bg-white px-6 pb-14">
        <div className="flex h-full flex-col gap-y-6 overflow-y-auto">
          <MenuBrowser setPage={setPage} />
          <h2 className="flex items-center text-xl !font-medium leading-8 !text-gray-1100">
            United States
          </h2>
          <NavSubItems
            page={page}
            seeAll={'/locations/'}
            toggleOpen={setOpen}
            currentlyOpen={state.open}
            items={US_LINKS}
            label="United States"
            shouldShowLabel={false}
            className="[&_a]:!text-gray-800"
          />
          <span className="flex text-gray-1100">
            <NavBrowseButton {...NavBrowseButtonProps} />
          </span>
        </div>
      </div>
    </motion.div>
  )
}

export default memo(UnitedStatesMenu)
